// Local dependencies
import { ResetError } from '../../../../common/types/reset-error';
import {
  CloseUpdateCategorySuccessPopup,
  UpdateCategory,
  UpdateCategoryActionTypes,
  UpdateCategoryError,
  UpdateCategoryInput,
  UpdateCategorySuccess,
} from './types';

export function updateCategory(input: UpdateCategoryInput): UpdateCategory {
  return {
    type: UpdateCategoryActionTypes.UPDATE_CATEGORY,
    input,
  };
}

export function updateCategorySuccess(): UpdateCategorySuccess {
  return {
    type: UpdateCategoryActionTypes.UPDATE_CATEGORY_SUCCESS,
  };
}

export function updateCategoryError(error: Error): UpdateCategoryError {
  return {
    type: UpdateCategoryActionTypes.UPDATE_CATEGORY_ERROR,
    error,
  };
}

export function closeUpdateCategorySuccessPopup(): CloseUpdateCategorySuccessPopup {
  return {
    type: UpdateCategoryActionTypes.CLOSE_UPDATE_CATEGORY_SUCCESS_POPUP,
  };
}

export function resetUpdateCategoryError(): ResetError<UpdateCategoryActionTypes.RESET_UPDATE_CATEGORY_ERROR> {
  return {
    type: UpdateCategoryActionTypes.RESET_UPDATE_CATEGORY_ERROR,
  };
}
